import React from "react"
import { Spin } from "antd"

import css from "./index.module.css"

export const LoadingBlock: React.FC = () => {
  return (
    <div className={css.loading_block}>
      <Spin size="large" style={{ margin: 20 }} />
    </div>
  )
}
